import React, { useEffect, useState } from 'react';
import { Download, Check, X } from 'lucide-react';
import { usePwaInstall } from '../hooks/usePwaInstall';

// Inline PWA install banner (floating, bottom-right). Dismissible, stores in localStorage.
// Actual prompt logic lives in the usePwaInstall hook (shared with PwaInstallButton).
export default function PwaInstallBanner() {
  const { canInstall, installed, iosHint, install } = usePwaInstall();
  const [dismissed, setDismissed] = useState(() => !!localStorage.getItem('pwa-install-dismissed-v1'));

  useEffect(() => {
    if (installed) localStorage.setItem('pwa-install-dismissed-v1', '1');
  }, [installed]);

  const dismiss = () => {
    localStorage.setItem('pwa-install-dismissed-v1', '1');
    setDismissed(true);
  };

  if (installed || dismissed || !canInstall) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-[360px] z-[60] pointer-events-auto" data-testid="pwa-install-banner">
      <div className="card-shell p-3 flex items-start gap-3 shadow-lg">
        <div className="w-10 h-10 rounded-xl grid place-items-center shrink-0" style={{ background: 'linear-gradient(135deg,#a78bfa,#22d3ee)' }}>
          <Download className="w-5 h-5 text-black" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-[14px]">Install ReaperCast</div>
          {iosHint ? (
            <div className="text-[12.5px] text-white/70 mt-1 leading-snug">Tap <span className="font-semibold">Share</span> → <span className="font-semibold">Add to Home Screen</span> for the full-screen app.</div>
          ) : (
            <div className="text-[12.5px] text-white/70 mt-1">One tap for an app-like experience — works offline too.</div>
          )}
          <div className="flex gap-2 mt-2">
            {!iosHint && <button onClick={async () => { const r = await install(); if (r === 'accepted') dismiss(); }} className="btn-primary text-[12px]" data-testid="pwa-install-btn"><Check className="w-3.5 h-3.5" /> Install</button>}
            <button onClick={dismiss} className="btn-ghost text-[12px]" data-testid="pwa-install-dismiss">Not now</button>
          </div>
        </div>
        <button onClick={dismiss} className="text-white/55 hover:text-white p-1" aria-label="Close"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
}
